<template>
	<div>
		<!-- <order :storeId ="storeId" :config ="config" v-if="pagetype=='_order'" @ement="ement"></order>
		<product :storeId ="storeId" :config ="config" v-else  @ement="ement"></product> -->
		<product :storeId ="storeId" :config ="config" @ement="ement"></product> -->
	</div>
</template>

<script>
	import order from '@/components/bar/record/_order.vue';
	import product from '@/components/bar/record/_product.vue';
export default {
	components: {order,product},
	props:['storeId'],
  	data(){
		return {
			pagetype:'',
			config:'COUNTER'
		}
	},
	watch:{
	   
	},
	methods:{
		ement(v){
			this.pagetype = v;
			sessionStorage.setItem('oun_in_bar',v);
		}
	},
	created () {
		if(!sessionStorage.getItem('oun_in_bar')){
			sessionStorage.setItem('oun_in_bar','_order');
		};
		this.pagetype = sessionStorage.getItem('oun_in_bar');
	},
	mounted() {
		
	},
	beforeDestroy() {
		sessionStorage.removeItem('oun_in_bar');
	}
}
</script>
<style lang="scss" scoped>
	@import "record";
</style>


// WEBPACK FOOTER //
// src/components/bar/record/record.vue